<template>
  <v-card
      flat
      rounded="0"
      class="mx-auto mt-1"
      max-width="800"
      mim-width="350">
    <v-container fluid>
      <v-card class="bg-grey-lighten-4" flat>
        <v-card-text class="pa-3 text-body-2 text-start text-grey-darken-1">
          최근 2주 동안의 구매리스트를 볼 수 있습니다.
        </v-card-text>
      </v-card>

      <v-container class="pa-0 pt-3 pb-3" fluid>
        <v-row class="ma-0">
          <v-col cols="3" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              주문일자
            </v-card-text>
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-text-field v-model="searchDateStart"
                          v-on:change="isValidSearchDateStart"
                          type="date"
                          class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
          <v-col cols="3" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 pl-2 text-body-2">
              부터
            </v-card-text>
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-1">
          <v-col cols="3" class="pa-0 text-start align-self-center">
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-text-field v-model="searchDateEnd"
                          v-on:change="isValidSearchDateEnd"
                          type="date"
                          class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
          <v-col cols="3" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 pl-2 text-body-2">
              까지
            </v-card-text>
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-2">
          <v-col cols="3" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              주문상태
            </v-card-text>
          </v-col>
          <v-col cols="6" class="pa-0">
            <v-select
                :items="searchStatusList"
                item-title="name"
                item-value="code"
                v-model="searchStatus"
                class="bg-white"
                density="compact"
                variant="outlined"
                location="bottom"
                label="주문상태 선택"
                single-line
                hide-details></v-select>
          </v-col>
          <v-col cols="3" class="pa-0 pl-3">
            <v-btn
                class="w-100 h-100 bg-primary"
                @click="searchList"
                variant="flat">
              조회
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-card v-if="orders.length > 0"
              class="pa-2 mt-2 rounded-lg" v-for="(order, index) in orders"
              :style="'border: 1px solid #BDBDBD'"
              @click="goHistoryDetail(index)"
              color="grey-darken-3" variant="outlined">
        <v-container fluid>
        <v-row class="pa-1">
            <v-col cols="3" class="pa-0">
              <v-card-text class="pa-0 text-body-2">주문날짜</v-card-text>
            </v-col>
            <v-col cols="9" class="pa-0">
              <v-card-text class="pa-0 text-body-2">{{formatDate(order.sale_date)}}</v-card-text>
            </v-col>
          </v-row>
          <v-row class="pa-1 pt-0">
            <v-col cols="3" class="pa-0">
              <v-card-text class="pa-0 text-caption">주문번호</v-card-text>
            </v-col>
            <v-col cols="9" class="pa-0">
              <v-card-text class="pa-0 text-caption">
                {{order.sale_date}}-{{order.bill_no}}-{{order.upjang_code}}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="pa-1 pb-0">
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 font-weight-bold text-body-1">{{order.upjang_name}}</v-card-text>
            </v-col>
          </v-row>
          <v-row class="pa-1 pt-0">
            <v-col cols="12" class="pa-0">
              <div class="text-end">
                <div v-if="order.order_stat === '001' || order.order_stat === '002' || order.order_stat === '003'">
                  <v-chip
                      color="primary"
                      size="small">
                    {{order.order_stat_name}}
                  </v-chip>
                </div>
                <div v-if="order.order_stat === '005'">
                  <v-chip
                      color="red"
                      size="small">
                    {{order.order_stat_name}}
                  </v-chip>
                </div>
                <div v-if="order.order_stat === '004' || order.order_stat === '006'">
                  <v-chip
                      color="grey-darken-3"
                      size="small">
                    {{order.order_stat_name}}
                  </v-chip>
                </div>
                <v-card-text class="pa-0 pt-1 font-weight-bold text-body-1">{{formatAmt(order.sale_amt)}}</v-card-text>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card v-if="orders.length <= 0"
              class="mt-4" color="grey-lighten-4" flat>
        <v-card-text class="text-body-2 text-center">
          주문 내역이 없습니다.
        </v-card-text>
        <v-card-text class="pt-0 text-center">
          <v-btn color="primary" to="/upjang" variant="tonal" size="small">주문하러가기</v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-card>

  <MobileFooter></MobileFooter>
</template>

<script>
import authStore from "@/store/auth";
import {order} from "@/api";
import commonStore from "@/store/common";
import MobileFooter from "@/components/common/MobileFooter";
import dayjs from "dayjs";

export default {
  name: "History",
  components: {
    MobileFooter,
  },
  data () {
    return {
      isAuth: false,
      orders: [],
      searchDateStart: dayjs().subtract(14, 'day').format('YYYY-MM-DD'),
      searchDateEnd: dayjs().format('YYYY-MM-DD'),
      searchStatus: '00',
      searchStatusList: [
        {name: '전체', code: '00', data: ['001', '002', '003', '004', '005', '006']},
        {name: '주문', code: '01', data: ['001', '002', '003', '004', '005']},
        {name: '취소', code: '02', data: ['006']}
      ],
    }
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    }
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    this.searchList()
  },
  methods: {
    searchList() {
      if (!this.searchDateStart || !this.searchDateEnd) {
        alert("주문일자를 선택해주세요.")
        return
      }

      this.searchStatusList.forEach((item) => {
        if (item.code === this.searchStatus) {
          order.getOrderInfoList(commonStore.state.common.corpCode,
              dayjs(this.searchDateStart).format('YYYYMMDD'),
              dayjs(this.searchDateEnd).format('YYYYMMDD'),
              item.data)
              .then(data => {
                console.log(data)
                if (data.data.orders) {
                  this.orders = data.data.orders
                }
              })
              .catch(err => {
                if (err.isAlert) {
                  alert(err.result.error_message)
                }
              })
        }
      })
    },
    goHistoryDetail(index) {
      this.$router.push("/order/history/" + this.orders[index].sale_date + "/" + this.orders[index].bill_no + "/" + this.orders[index].upjang_code)
    },
    isValidSearchDateStart() {
      if (dayjs(this.searchDateStart).isAfter(dayjs())) {
        this.searchDateStart = this.searchDateEnd
        alert("주문일자를 오늘 혹은 최근 2주 이내 일자로 선택해주세요.")
        return false
      }

      if (dayjs(this.searchDateStart).isBefore(dayjs().subtract(15, 'day'))) {
        this.searchDateStart = dayjs().subtract(14, 'day').format('YYYY-MM-DD')
        alert("주문일자를 최근 2주 이내 일자로 선택해주세요.")
        return false
      }

      if (dayjs(this.searchDateStart).isAfter(this.searchDateEnd)) {
        this.searchDateEnd = this.searchDateStart
      }
    },
    isValidSearchDateEnd() {
      if (dayjs(this.searchDateEnd).isAfter(dayjs())) {
        this.searchDateEnd = dayjs().format('YYYY-MM-DD')
        alert("주문일자를 오늘 혹은 최근 2주 이내 일자로 선택해주세요.")
        return false
      }

      if (dayjs(this.searchDateEnd).isBefore(dayjs().subtract(15, 'day'))) {
        this.searchDateEnd = this.searchDateStart
        alert("주문일자를 최근 2주 이내 일자로 선택해주세요.")
        return false
      }

      if (dayjs(this.searchDateEnd).isBefore(this.searchDateStart)) {
        this.searchDateStart = this.searchDateEnd
      }
    },
  }
}
</script>

<style scoped>

</style>